import React from "react";
import { IntlProvider } from "react-intl";
import { wrappedDisplayName } from "../i18n/IntlRootMixin";
import { locale, formats, messagesForAllProjects } from "../i18n/i18nDataProvider";

export function withIntlRootProvider<P>(WrappedComponent: React.ComponentType<P>): React.ComponentType<P> {
    class Wrapper extends React.Component<P> {
        render() {
            return (
                <IntlProvider
                    locale={locale}
                    messages={Object.values(messagesForAllProjects).reduce(
                        (acc, translation) => ({ ...acc, ...translation }),
                        {}
                    )}
                    formats={formats}>
                    <WrappedComponent {...this.props} />
                </IntlProvider>
            );
        }

        static readonly displayName = wrappedDisplayName("withIntlRoot", WrappedComponent);
    }

    return Wrapper;
}
